import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { serverurl } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HealthService {
    public serverVersion$ = new BehaviorSubject<string | null>(null);

    private httpClient = inject(HttpClient);

    public getServerVersion$(): Observable<{ version: string }> {
        return this.httpClient.get<{ version: string }>(
            `${serverurl}/health/version`,
        )
            .pipe(
                tap((version) => this.serverVersion$.next(version.version)),
            );
    }
}

